<template>
  <div class="screen page accounts b-soft">
    <div class="grid">
      <section class="layout">
        <div class="container">
          <div class="row h-items-center">
            <GetAccounts />
          </div>
        </div>
      </section>
      <GetFooter />
    </div>
  </div>
</template>

<script>
import GetFooter from '@/components/footer.vue'
import GetAccounts from '@/components/accounts.vue'
export default {
  name: 'app',
  components: {
    GetFooter,
    GetAccounts
  }
}
</script>